/* =========================================================
   MAISON FERVEUR — Guide cadeau · JS unique (aucune bibliothèque)
   Rôle : flèches des rangées « Choisis selon son âge », fin du bandeau d'offre,
   espaces insécables d'affichage dans les titres (« » : ?), sans changer le texte du HTML.
   Les cartes et les produits sont dans le HTML ; le JS ne crée rien.
   ========================================================= */
(function(){
  /* Bandeau d'offre : masqué à l'heure exacte de fin (data-mf-fin, secondes Unix) */
  [].forEach.call(document.querySelectorAll('[data-mf-fin]'),function(el){var f=+el.getAttribute('data-mf-fin');if(f&&Date.now()/1000>=f){el.hidden=true}});

  /* Titres : pas de « : », « ? » ou guillemet seul en début de ligne */
  [].forEach.call(document.querySelectorAll('.mf-guide h1,.mf-guide h2,.mf-guide h3,.mf-guide h4,.mf-guide .mf-mini__name a,.mf-guide .mf-card__name a'),function(h){
    var w=document.createTreeWalker(h,NodeFilter.SHOW_TEXT,null),n;
    while((n=w.nextNode())){var v=n.nodeValue,r=v.replace(/ ([:?!;»])/g,' $1').replace(/« /g,'« ');if(r!==v)n.nodeValue=r}
  });

  /* Choix par âge : une rangée par âge, défilement horizontal des t-shirts. Flèches masquées s'il n'y a rien à faire défiler. */
  var smooth=!window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  [].forEach.call(document.querySelectorAll('[data-mf-agerow]'),function(row){
    var t=row.querySelector('[data-mf-row]'),p=row.querySelector('[data-mf-prev]'),n=row.querySelector('[data-mf-next]'),nav=row.querySelector('.mf-row-nav');
    if(!t||!p||!n||!nav)return;
    function step(){var c=t.children[0];return c?c.getBoundingClientRect().width+12:240}
    function sync(){var over=t.scrollWidth>t.clientWidth+4;nav.style.visibility=over?'':'hidden';p.disabled=t.scrollLeft<4;n.disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-4}
    p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:smooth?'smooth':'auto'})});
    n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:smooth?'smooth':'auto'})});
    t.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();n.click()}if(e.key==='ArrowLeft'){e.preventDefault();p.click()}});
    var tm;t.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(sync,60)},{passive:true});
    window.addEventListener('resize',sync);window.addEventListener('load',sync);
    if('ResizeObserver' in window){new ResizeObserver(sync).observe(t)}
    sync();
  });
})();
